import { render, staticRenderFns } from "./Protocolo.vue?vue&type=template&id=612e9696&"
import script from "./Protocolo.vue?vue&type=script&lang=js&"
export * from "./Protocolo.vue?vue&type=script&lang=js&"
import style0 from "./Protocolo.vue?vue&type=style&index=0&id=612e9696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports